// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ExternalLinkType } from './Branding/ExternalLinkType';
import { ExtLinkClientTab } from './ExtLinkClientTab';
import { ResourcesManager } from '../../properties/ResourcesManager';
export var AttachingArea;
(function (AttachingArea) {
    AttachingArea[AttachingArea["PopUp"] = 0] = "PopUp";
    AttachingArea[AttachingArea["AttachPanel"] = 1] = "AttachPanel";
})(AttachingArea || (AttachingArea = {}));
export class BaseExtLink {
    constructor() {
        this.id = -1;
        this._urlStr = '';
        this.name = '';
        this.clientTab = ExtLinkClientTab.MORE;
        this.clientTabName = '';
        this.clientUseInternalBrowser = false;
        this.aliases = new Map();
        this.brandingToolExtResource = ExternalLinkType.NONE;
        this.attachingArea = AttachingArea.PopUp;
        this.description = null;
        this.url = null;
        this.isOpenWithPost = false;
    }
    get urlStr() {
        return this._urlStr;
    }
    set urlStr(value) {
        this._urlStr = value;
        this.generateUrl();
    }
    update(brandingTool, extLinkMessage) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.id = (_a = extLinkMessage.Id) !== null && _a !== void 0 ? _a : this.id;
        this.name = (_b = extLinkMessage.Name) !== null && _b !== void 0 ? _b : this.name;
        this.urlStr = (_c = extLinkMessage.Url) !== null && _c !== void 0 ? _c : this.urlStr;
        this.clientUseInternalBrowser = (_d = extLinkMessage.UseInternalBrowser) !== null && _d !== void 0 ? _d : this.clientUseInternalBrowser;
        this.brandingToolExtResource = (_e = extLinkMessage.ExternalResource) !== null && _e !== void 0 ? _e : this.brandingToolExtResource;
        this.clientTab = (_f = brandingTool === null || brandingTool === void 0 ? void 0 : brandingTool.clientTab) !== null && _f !== void 0 ? _f : this.clientTab;
        this.clientTabName = (_g = brandingTool === null || brandingTool === void 0 ? void 0 : brandingTool.clientTabName) !== null && _g !== void 0 ? _g : this.clientTabName;
        this.attachingArea = (_h = brandingTool === null || brandingTool === void 0 ? void 0 : brandingTool.attachingArea) !== null && _h !== void 0 ? _h : this.attachingArea;
        this.description = (_j = brandingTool === null || brandingTool === void 0 ? void 0 : brandingTool.description) !== null && _j !== void 0 ? _j : this.description;
        this.aliases.clear();
        (_k = brandingTool === null || brandingTool === void 0 ? void 0 : brandingTool.aliases) === null || _k === void 0 ? void 0 : _k.forEach((alias) => {
            this.aliases.set(alias.lang, alias);
        });
    }
    getLocalizedToolName() {
        var _a;
        const alias = this.aliases.get(ResourcesManager.GetCurrentAppLang());
        return (_a = alias === null || alias === void 0 ? void 0 : alias.toolName) !== null && _a !== void 0 ? _a : this.name;
    }
    getLocalizedTabNameOrNull() {
        const alias = this.aliases.get(ResourcesManager.GetCurrentAppLang());
        if (!isNullOrUndefined(alias === null || alias === void 0 ? void 0 : alias.tabName)) {
            return alias.tabName;
        }
        return null;
    }
    getUrl() {
        this.generateUrl();
        return this.url;
    }
    getUrlForExternalBrowser() {
        return this.urlStr;
    }
    generateUrl() {
        // Implementation logic should go here
    }
    isAttached() {
        return this.attachingArea === AttachingArea.AttachPanel;
    }
    IsNoneLink() {
        return this.brandingToolExtResource === ExternalLinkType.NONE;
    }
    getIsOpenWithPost() {
        return this.isOpenWithPost;
    }
    getPostData() {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
}
